import React from 'react'

function Base() {
  return (
    <div className="flex flex-1 flex-col flex-wrap p-8 justify-center items-center text-center h-screen w-full">
    <img src="/assets/logo_textless.svg" alt="logo" />
    <h2 className="text-3xl font-bold w-full">Welcome to Foxrest</h2>
    <p className="mt-4 text-lg">Select an option from the sidebar to proceed.</p>
  </div>
  )
}

export default Base